<template>
  <div class="w-full flex items-center justify-center">
    <button
      class="px-8 py-2 border md:hover:bg-black uppercase md:hover:text-white duration-300 border-black font-primary text-black rounded-full"
      @click="scrollToTop"
    >
      Zurück <br />
      nach oben
    </button>
  </div>
</template>

<script setup>

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
</script>
